import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { arrayByLength } from "../../../../../shared";
import { SLIDE_NUMBER } from "../constants";

export async function getDefaultMark(dictionariesService: DictionariesService) {
  const lastYearCalendar = await dictionariesService.getDictionary({
    id: 'slides-f-last-calendar',
    parameters: {
      attributes: '',
      units: '',
      commodities: '',
      countries: '',
      slide: SLIDE_NUMBER,
    },
  });
  const lastYearCalendarItems = await lastYearCalendar.getAll();

  const dictionaryCalendar = await dictionariesService.getDictionary({
    id: 'calendar-origin',
    parameters: {},
  });
  const calendarItems = await dictionaryCalendar.getAll();
  const currentYear = (new Date()).getFullYear();
  const limitDateId = Number(lastYearCalendarItems[0]?.id || `1${currentYear}0101`);
  const limitDateFrequency = Number(String(limitDateId)[0]);
  const maxYearId = Number(`1${String(limitDateId).slice(1, 5)}0101`);
  const minYearId = 120100101;
  const [yearStep, yearFrequency, weekFrequency, monthFrequency] = [10000, 1, 7, 4];
  const countLastYears = (maxYearId - minYearId) / yearStep + 1;
  const yearsIds = arrayByLength(countLastYears).map((_, i) => maxYearId - (i * yearStep));
  const sordetItems = calendarItems.sort((a, b) => Number(a.id) - Number(b.id));
  const allChildren = sordetItems.reduce((result, item) => {
    const isPrimaryChild = yearsIds.includes(Number(item.id));
    const parentId = item.getValue<number | string>("parent")?.toString();
    const isSecondaryChild = result.some(parentCandidate => parentCandidate.id === parentId);
    const isChild = isPrimaryChild || isSecondaryChild;
    if (isChild) {
      const itemFrequency = Number(item.id[0]);
      if (limitDateFrequency !== itemFrequency || Number(item.id) <= limitDateId) {
        result.push(item);
      }
    }
    return result;
  }, [] as DictionaryItem[]);

  const calendarValuesItems = allChildren.filter(item => [yearFrequency, weekFrequency, monthFrequency].includes(item.getValue<number>("frequencyId")!));

  return {
    calendar: calendarValuesItems.map(item => Number(item.id)),
  };
}